import { createFileRoute } from "@tanstack/react-router"

import { EditorialIndex } from "@/components/content-display"
import { getPublicContentFn } from "@/lib/app.functions"

export const Route = createFileRoute("/events")({
  loader: () => getPublicContentFn({ data: { kind: "event" } }),
  head: () => ({
    meta: [{ title: "Open houses · Harbor & Pine Realty" }],
  }),
  component: EventsPage,
})

function EventsPage() {
  return (
    <EditorialIndex
      eyebrow="Viewing calendar"
      title="Open houses & briefings"
      intro="Fictional events demonstrate how scheduled content connects prospective buyers, published listings, and the inquiry workflow."
      items={Route.useLoaderData()}
      kind="events"
    />
  )
}
